"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("../table/utils");
const breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
const normalizeControlsPerRow = controlsPerRow => {
  const res = {};
  let previousValue = 1;
  breakpoints.forEach(breakpoint => {
    if (controlsPerRow[breakpoint] !== undefined) {
      previousValue = controlsPerRow[breakpoint];
    }
    res[breakpoint] = previousValue;
  });
  return res;
};
var _default = exports.default = {
  name: 'YsSearchForm',
  inject: {
    ysProviderContext: {
      default: () => ({
        searchForm: {}
      })
    }
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    formConfig: {
      type: Array,
      default: () => {
        return [];
      }
    },
    // Form的props
    formProps: {
      type: Object,
      default: () => {}
    },
    // 是否显示loading状态
    loading: {
      type: Boolean,
      default: false
    },
    defaultCollapse: {
      type: Boolean,
      default: true
    }
  },
  data() {
    const layoutControlsPerRow = normalizeControlsPerRow(this.ysProviderContext.searchForm.controlsPerRow ?? {
      xs: 1,
      md: 2,
      lg: 3,
      xl: 6
    });
    return {
      formData: this.value,
      collapse: this.defaultCollapse,
      showCollapse: true,
      layoutClass: '',
      mediaQueries: {
        xs: window.matchMedia('(max-width: 1023px)'),
        sm: window.matchMedia('(min-width: 1024px) and (max-width: 1199px)'),
        md: window.matchMedia('(min-width: 1200px) and (max-width: 1599px)'),
        lg: window.matchMedia('(min-width: 1600px) and (max-width: 1919px)'),
        xl: window.matchMedia('(min-width: 1920px)')
      },
      layoutControlsPerRow,
      currentControlsPerRow: 0,
      open: false
    };
  },
  computed: {
    renderFormConfig() {
      return this.formConfig.filter(item => (0, _utils.getBoolean)(item.visible));
    },
    controlWidth() {
      return `${100 / this.currentControlsPerRow}%`;
    },
    placeholderColsNum() {
      if (this.collapse || this.currentControlsPerRow === 0) {
        return 0;
      }
      return this.currentControlsPerRow - this.renderFormConfig.length % this.currentControlsPerRow - 1;
    }
  },
  watch: {
    value: {
      deep: true,
      handler(value) {
        this.formData = value;
      }
    },
    formData: {
      deep: true,
      handler(value) {
        this.$emit('input', value);
      }
    }
  },
  mounted() {
    this.initMediaQuery();
    this.mediaQueryChange();
  },
  beforeDestroy() {
    Object.values(this.mediaQueries).forEach(query => {
      query.removeEventListener('change', this.mediaQueryChange);
    });
  },
  methods: {
    initMediaQuery() {
      Object.values(this.mediaQueries).forEach(query => {
        query.addEventListener('change', this.mediaQueryChange);
      });
    },
    mediaQueryChange() {
      const layoutControlsPerRow = this.layoutControlsPerRow;
      const {
        xs,
        sm,
        md,
        lg,
        xl
      } = this.mediaQueries;
      const formConfigLength = this.renderFormConfig.length;
      let breakpoint = 'xs';
      if (xs.matches) {
        breakpoint = 'xs';
      } else if (sm.matches) {
        breakpoint = 'sm';
      } else if (md.matches) {
        breakpoint = 'md';
      } else if (lg.matches) {
        breakpoint = 'lg';
      } else if (xl.matches) {
        breakpoint = 'xl';
      }
      this.currentControlsPerRow = layoutControlsPerRow[breakpoint];
      this.layoutClass = `layout-cols-${this.currentControlsPerRow}`;
      this.showCollapse = formConfigLength >= this.currentControlsPerRow;
      if (!this.showCollapse) {
        this.collapse = false;
      }
    },
    isLabelVisible(item) {
      switch (typeof item.label) {
        case 'undefined':
        case 'boolean':
          return item.label;
        case 'function':
          return item.label();
        default:
          return true;
      }
    },
    handleMonthRangePanelChange(value, mode, field) {
      this.formData[field] = value;
    },
    handleYearDatePanelChange(value, mode, field) {
      this.formData[field] = new Date(value).getFullYear().toString();
      this.open = false;
    },
    handleYearDateOpenChange(open) {
      this.open = open;
    },
    search() {
      this.$emit('search');
    },
    reset() {
      this.$refs.form.resetFields();
    },
    handleReset() {
      this.reset();
      this.$emit('reset');
    },
    handleCollapse() {
      this.collapse = !this.collapse;
      this.$emit('collapse', this.collapse);
    }
  }
};